/**
 * Home IA · Radar de conocimiento R4 (ADR-HomeIA-R4). Modelo espejo del DTO del agregador
 * `GET /api/home-ia/knowledge-attention` (camelCase). Read-only: sólo lo que el backend ya
 * recortó por permisos de fuente. No incluye snippets ni filenames de fuentes restringidas.
 */

export type KnowledgeSectionStatus = 'ok' | 'empty' | 'error';

/** Un próximo vencimiento documental (evidencia siempre presente; versión activa; fuente legible). */
export interface KnowledgeExpirationItem {
  id: string;
  entityId?: string | null;
  documentId: string;
  expiresOn: string;
  kind: string;
  originalText: string;
  context: string;
  confidence?: number | null;
}

/** Una entidad con actividad reciente (sourceCount y lastSeenAt sólo sobre fuentes visibles). */
export interface KnowledgeRecentEntityItem {
  id: string;
  type: string;
  name: string;
  sourceCount: number;
  lastSeenAt: string;
}

export interface KnowledgeAttentionSection<T> {
  status: KnowledgeSectionStatus;
  items: T[];
}

export interface KnowledgeAttentionResponse {
  featureAvailable: boolean;
  generatedAt: string;
  expirations: KnowledgeAttentionSection<KnowledgeExpirationItem>;
  recentEntities: KnowledgeAttentionSection<KnowledgeRecentEntityItem>;
  warnings: string[];
}

/** Parámetros opcionales del radar (el backend clampa; el front sólo sugiere top-N y horizonte). */
export interface KnowledgeAttentionParams {
  expirationDays?: number;
  expirationLimit?: number;
  entityLimit?: number;
}

/**
 * Respuesta "feature no disponible": se usa cuando el endpoint responde 404 (plan sin
 * `knowledge_hub`) para que los widgets se oculten por completo, sin propagar el error.
 */
export const KNOWLEDGE_ATTENTION_FEATURE_OFF: KnowledgeAttentionResponse = {
  featureAvailable: false,
  generatedAt: '',
  expirations: { status: 'empty', items: [] },
  recentEntities: { status: 'empty', items: [] },
  warnings: [],
};
